import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// codeGrp에 해당하는 base_code 데이터 리턴
function getBaseCodeFromMomthera({codeGrp}) {
    return AxiosInterceptor({
        url: `/base/code/${codeGrp}`,
        method: 'get'
    })
}

export default getBaseCodeFromMomthera;